import { TheoreticalTemplateWizardStore } from './theoretical-template-wizard-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new TheoreticalTemplateWizardStore());
}
